import axios from "axios";
import { atom } from "nanostores";
import { BASE_URL } from "../utils/constants";
import { scopedLocalStorage, scopedSessionStorage } from "../utils/storage";
import {
  is_feedback_collected,
  is_feedback_form_open,
  is_feedback_form_enabled,
  client_id,
} from "./chat";

export const isOpen = atom<boolean>(false);
export const hasOpened = atom<boolean>(false);
export const isConfigLoaded = atom<boolean>(false);

export const openWidget = () => {
  isOpen?.set(true);
  if (!hasOpened?.get()) {
    hasOpened?.set(true);
    scopedSessionStorage?.setItem("chatbot_opened", "true");
  }
};

export const closeWidget = () => {
  isOpen?.set(false);
};

const handleWidgetToggle = () => {
  isConfigLoaded?.set(true);
  if (
    isOpen?.get() &&
    (client_id.get() === "vita" ||
      client_id.get() === "houseofsocial" ||
      client_id.get() === "nowstudents" ||
      client_id.get() === "herestudents" ||
      client_id.get() === "aparto")
  ) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "live_chat_exit",
    });
  } else if (!isOpen?.get() && client_id.get() === "aparto") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "chat_opened",
    });
  }
  isOpen?.set(!isOpen?.get());
  if (!hasOpened?.get()) {
    hasOpened?.set(true);
    scopedSessionStorage?.setItem("chatbot_opened", "true");
  }
};

const skipFeedback = async () => {
  const user_id = scopedLocalStorage.getItem("user_id");
  const session_id = JSON.parse(scopedLocalStorage.getItem("session_info") || "{}")
    ?.id;
  await axios.post(`${BASE_URL}/fe/update_feedback_status`, {
    user_id,
    session_id,
  });
};

const fetchFeedbackCollected = async (): Promise<boolean> => {
  const user_id = scopedLocalStorage.getItem("user_id");
  if (!user_id) return true; // no user -> treat as collected, just close
  try {
    const { data } = await axios.get(
      `${BASE_URL}/fe/feedback_collected/${user_id}`
    );
    // API returns feedback_collected as a string: "true" | "false" | "null".
    // Only show the feedback form when it is exactly "false"; treat "true",
    // "null", or anything else as "already handled" so the widget just closes.
    return String(data?.feedback_collected).toLowerCase() !== "false";
  } catch {
    return true; // on error -> just close
  }
};

export const toggleWidget = async () => {
  const isWidgetOpen = isOpen?.get();
  const isFeedbackFormOpen = is_feedback_form_open?.get();
  const isFeedbackEnabled = is_feedback_form_enabled?.get();

  if (!isWidgetOpen) {
    handleWidgetToggle();
  } else if (!isFeedbackEnabled) {
    handleWidgetToggle();
  } else if (isFeedbackFormOpen) {
    // Feedback form is showing - close the widget and skip feedback
    is_feedback_collected?.set(true);
    is_feedback_form_open?.set(false);
    scopedSessionStorage?.setItem("is_feedback_form_open", "false");
    handleWidgetToggle();
    await skipFeedback();
  } else {
    // Ask the backend whether feedback was already collected for this session
    const feedbackCollected = await fetchFeedbackCollected();
    if (feedbackCollected) {
      handleWidgetToggle(); // "null" / "true" / other -> just close
    } else {
      is_feedback_form_open?.set(true); // "false" -> open the feedback form
      scopedSessionStorage?.setItem("is_feedback_form_open", "true");
    }
  }
};

export const configLoaded = () => {
  isConfigLoaded?.set(true);
};
